import LegalShell, { LegalSection } from "../components/LegalShell";

export default function Terms() {
  return (
    <LegalShell eyebrow="Legal" title="Terms of Use">
      <p>
        By using Cavilow you agree to these Terms of Use. Please read them carefully — they describe what Cavilow does
        (and doesn't do) and what we expect from you.
      </p>

      <LegalSection title="What Cavilow is">
        <p>
          Cavilow is a career assistance platform that helps users improve resumes, generate tailored documents,
          discover matching job opportunities, and prepare for interviews. It is an advisory and productivity tool.
        </p>
      </LegalSection>

      <LegalSection title="No guarantee of outcomes">
        <p>
          Cavilow does not guarantee job offers, interviews, hiring outcomes, or any specific ATS score. Outcomes
          depend on many factors outside Cavilow's control.
        </p>
      </LegalSection>

      <LegalSection title="ATS scores are estimates">
        <p>
          ATS scores shown in Cavilow are estimates produced by our analysis and may vary across actual Applicant
          Tracking Systems used by employers.
        </p>
      </LegalSection>

      <LegalSection title="Third-party job listings">
        <p>
          Job listings and links shown in Cavilow may come from third-party platforms (e.g. LinkedIn, Indeed, Bayt,
          Naukri, SEEK, and others). Cavilow does not control those platforms or the accuracy of their listings.
        </p>
      </LegalSection>

      <LegalSection title="Your responsibility">
        <p>
          You are responsible for reviewing generated resumes, cover letters, and application content for accuracy and
          appropriateness before submitting them to any employer.
        </p>
      </LegalSection>

      <LegalSection title="Truthful content">
        <p>
          Cavilow does not create fake experience, fake companies, fake education, fake certifications, or false
          achievements. Cavilow only rephrases, restructures, and improves the keyword visibility of content you
          provide. Submitting falsified information remains your responsibility.
        </p>
      </LegalSection>

      <LegalSection title="Support">
        <p>
          For questions, account help, or to exercise your data rights, contact{" "}
          <a href="mailto:contactcavilow@gmail.com" className="text-[#80FFEA] font-semibold hover:underline">
            contactcavilow@gmail.com
          </a>
          .
        </p>
      </LegalSection>
    </LegalShell>
  );
}
